import { useState } from 'react';
import { PiPlayBold } from "react-icons/pi";
import { IoIosCalculator } from "react-icons/io";
import { BiDollar } from "react-icons/bi";
import { FaArrowRight } from "react-icons/fa6";


interface PredictionRange {
  id: string;
  label: string;
  multiplier: string;
  value: number;
}

export default function BettingInterface() {
  const [selectedRange, setSelectedRange] = useState<string>('100k-200k');
  const [betAmount, setBetAmount] = useState<number>(100);

  const predictionRanges: PredictionRange[] = [
    { id: '0-50k', label: '0-50k views', multiplier: '1.8x', value: 1.8 },
    { id: '50k-100k', label: '50k-100k views', multiplier: '2.8x', value: 2.8 },
    { id: '100k-200k', label: '100k-200k views', multiplier: '4.2x', value: 4.2 },
    { id: '200k+', label: '200k+ views', multiplier: '6.5x', value: 6.5 }
  ];

  const quickAmounts = [50, 100, 250, 500];


  return (
    <section className="section betting-interface">
      <div className="container">
        <div className="section-header text-center">
          <h1>Simple betting interface</h1>
          <p>Select a range, enter your bet, see projected payouts</p>
        </div>

        <div className="interface-showcase">
          <div className="video-showcase">
            <div className="video-mockup">
              <div className="video-mockup-header">
                <span className="video-time">3:21</span>
              </div>

              <div className="video-play-area">
                <div className="video-play-icon">
                  <PiPlayBold />
                </div>
              </div>

              <span className="video-views"> Current: 1.2M views</span>
            </div>
            <div className="video-info-card">
                <h3>How many views will this video reach?</h3>
                <p className="prediction-window">Prediction window: 24 hours</p>

                <div className="video-stats">
                  <div className="stat-item">
                    <span className="stat-label">Total pool</span>
                    <span className="stat-value">$24,900</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-label">Predictions</span>
                    <span className="stat-value">1,423</span>
                  </div>
                </div>
            </div>
          </div>

          {/* Betting Panel */}
          <div className="betting-panel">
            <div className="betting-panel-header">
              <div className="betting-panel-header-icon">
                <IoIosCalculator />
              </div>
              <div className="betting-panel-header-text">
                <h3>Place your bet</h3>
                <p>Choose a view range</p>
              </div>
            </div>

            <p>Select prediction range</p>
            <div className="prediction-ranges">
              {predictionRanges.map((range) => (
                <button
                  key={range.id}
                  className={`range-option ${selectedRange === range.id ? 'active' : ''}`}
                  onClick={() => setSelectedRange(range.id)}
                >
                  <span className="range-label">{range.label}</span>
                </button>
              ))}
            </div>

            <div className="bet-amount-section">
              <label>Bet amount</label>
              <div className="bet-amount-input">
                <span className="usdc-icon"><BiDollar /></span>
                <span className="usdc-label">USDC</span>
                <input
                  type="number"
                  value={betAmount}
                  onChange={(e) => setBetAmount(Number(e.target.value))}
                  min="0"
                />
              </div>

              <div className="quick-amounts">
                {quickAmounts.map((amount) => (
                  <button
                    key={amount}
                    className="quick-amount-btn"
                    onClick={() => setBetAmount(amount)}
                  >
                    ${amount}
                  </button>
                ))}
              </div>
            </div>

            <button className="btn-confirm">
              Confirm prediction <FaArrowRight />
            </button>

          </div>
        </div>
      </div>
    </section>
  );
}
